import * as React from "react"
import * as Immutable from 'immutable'

import { Theme } from "../../../types/types";

import Truncate from 'react-truncate';
import * as Sanatize from 'sanitize-html';

type Props = {
  themes: Immutable.List<Theme>
}

export default (props: Props) : JSX.Element => {

  let class_toggle = false
  return (<>
    {
      props.themes.map((theme) => {
        class_toggle = !class_toggle
        return (<div key={theme.id} className={`${class_toggle ? "background-grey" : "background-purple"} grid-50 tablet-grid-50`}>
          <div className={`box ${class_toggle ? "box--grey" : "box--purple"}`}>
            <div className='box__body'>
              <img className="iar" src={theme.illustration.url} />
              <h2 className='h1 box__title'>{theme.featuredTitle || theme.name}</h2>
              <p>
                <Truncate
                  lines={4}
                >
                  {Sanatize(theme.bodyContent, { allowedTags: [] } )}
                </Truncate>
              </p>
              <p><a className="btn btn--primary btn--medium" href={theme.path}>{I18n.t('read_more')} {theme.readMoreText}</a></p>
            </div>
          </div>
        </div>)
      })
    }
  </>)
}
